export enum LeadAutomationActionType {
NotifyUser,
Clone,
TransformToProject,
InvokeEndpoint,
}
